import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

//Policy 选择变化时, 根据选中的 Policy 重新加载对应的 Code 下拉选项
export function getPlanningInstrumentCodeSelectOptionList({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  //parameter 是选中的 PlanningInstrumentOptionId
  if (parameter === null || parameter === undefined || parameter === '') {
    //未选 Policy, 清空 Code 下拉和已选值
    let componentDataSource = { ...formComponent.state.componentDataSource };
    componentDataSource['CodeIdList'] = [];
    formComponent.setState({ componentDataSource });
    formComponent.formRef.current?.setFieldValue('CodeIdList', []);
    return;
  }

  httpClient
    .get('Admin/PlanningInstrumentCode/GetSelectOptionListByOption?planningInstrumentOptionId=' + parameter)
    .then(({ data }) => {
      if (data.result) {
        let dataSource = data.data.map(item => ({ ...item, Value: Number(item.Value) }));
        let componentDataSource = { ...formComponent.state.componentDataSource };
        componentDataSource['CodeIdList'] = dataSource;
        formComponent.setState({ componentDataSource });

        //过滤掉已选但不属于新 Policy 的 Code (防止 Policy 变化后出现无效选项)
        let currentCodeIdList = formComponent.formRef.current?.getFieldValue('CodeIdList') || [];
        let validValues = dataSource.map(item => item.Value);
        let filtered = currentCodeIdList
          .map(id => Number(id))
          .filter(id => validValues.indexOf(id) >= 0);
        formComponent.formRef.current?.setFieldValue('CodeIdList', filtered);
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function editJobPlanningInstrumentPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie, data } = {}) {
  setTimeout(() => {
    let formComponent = sectionComponent.customForm.current;

    let componentDataSource = { ...formComponent.state.componentDataSource };
    if (componentDataSource['PlanningInstrumentOptionId']) {
      componentDataSource['PlanningInstrumentOptionId'] = componentDataSource['PlanningInstrumentOptionId'].map(item => ({
        ...item,
        Value: item.Value === '' || item.Value === null || item.Value === undefined ? item.Value : Number(item.Value)
      }));
      formComponent.setState({ componentDataSource });
    }
    formComponent.formRef.current?.setFieldValue('PlanningInstrumentOptionId', Number(data.PlanningInstrumentOptionId));
    
    getPlanningInstrumentCodeSelectOptionList({
      sectionName: sectionName,
      parameter: data.PlanningInstrumentOptionId,
      formComponent: formComponent,
      sectionComponent: sectionComponent,
      pageComponent: pageComponent
    });
  }, config.setTimeoutMilliSecond);
}
